import { vendorBrandsSlice } from '../slices/vendorBrandsSlice';

export default vendorBrandsSlice.reducer;
